import React from 'react'
import styles from './searchInput.module.scss'

export type SearchInputProps = {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  /** Accessible name — only needed when the placeholder is not descriptive enough. */
  ariaLabel?: string
  /** Sizing and placement of the wrapper (fixed width, sticky row, margins). */
  className?: string
  inputRef?: React.Ref<HTMLInputElement>
}

/**
 * Rounded search field with a leading magnifier, used by the proposal's product
 * filter and by the store list. Both had grown their own copy of the same
 * markup and CSS; the store one had already fixed the glyph centring that the
 * other still got wrong.
 *
 * The magnifier is a Unicode glyph rather than an image: the client SPA ships no
 * icon assets.
 */
export const SearchInput = ({
  value,
  onChange,
  placeholder,
  ariaLabel,
  className,
  inputRef,
}: SearchInputProps): React.ReactElement => (
  <div className={['modul', className ?? ''].filter(Boolean).join(' ')}>
    {/* U+2315 TELEPHONE RECORDER, used as a magnifier — not an ASCII letter. */}
    <span className={`txt-light-kale ${styles['search-input__icon']}`} aria-hidden="true">
      ⌕
    </span>
    <input
      ref={inputRef}
      type="search"
      className={`border-xxl bg-white full-width txt-kale ${styles['search-input__field']}`}
      placeholder={placeholder}
      aria-label={ariaLabel}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    />
  </div>
)
